import React from 'react';
import moment from 'moment';
import { Field } from 'react-final-form';
// @ts-ignore
import { RenderDropdown } from 'forms';

interface State {
    options: {
        text: string;
        value: string;
    }[];
}

interface Props {
    name: string;
    label?: string;
    validate?: any;
    initialDate?: string;
}

export default class WeekDropdown extends React.PureComponent<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            options: []
        };
    }

    componentDidMount(): void {
        const { initialDate } = this.props;
        const mondayOfTheWeek =
            (initialDate && moment(initialDate)) || moment().weekday(1);

        const startDate = moment(mondayOfTheWeek).subtract(1, 'week');
        let currentDate = moment(startDate);
        const endDate = moment(startDate).add(5, 'week');

        const options = [];

        while (!currentDate.isSame(endDate)) {
            options.push({
                text: `${currentDate.format('dddd Do MMM')} - ${moment(
                    currentDate
                )
                    .add(6, 'days')
                    .format('dddd Do MMM')}`,
                value: currentDate.format('YYYY-MM-DD')
            });

            currentDate = moment(currentDate).add(1, 'week');
        }

        this.setState({ options });
    }

    render(): React.ReactElement {
        const { options } = this.state;
        const { name, validate, label } = this.props;

        return (
            <Field
                component={RenderDropdown as any}
                subscription={{
                    value: true,
                    touched: true,
                    error: true
                }}
                name={name}
                validate={validate}
                label={label || 'Week'}
                placeholder="Select a week"
                fluid
                search
                selection
                clearable
                selectOnBlur={false}
                options={options}
            />
        );
    }
}
